export function resolveDiscardDraftRoute(currentHash) {
  return currentHash === '#sell' ? null : '#sell';
}
